module.exports = __webpack_public_path__ + "img/CX.7ce715e7.svg";